import React, {MouseEventHandler} from 'react';
import {NavItem, NavLink} from 'reactstrap';
import {Link} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {IconProp} from '@fortawesome/fontawesome-svg-core';

interface propiedades {
  label: string;
  linkTo: string | null;
  icon: IconProp;
  event: MouseEventHandler;
}

const ItemMenu = (props: propiedades) => {
  const {label, linkTo, icon, event} = props;
  return (
    <NavItem className="border-primary">
      <NavLink
        tag={Link}
        to={linkTo}
        onClick={event}
        className="color-primary text-start"
      >
        <FontAwesomeIcon icon={icon} className="me-2" />
        <FormattedMessage id={label} defaultMessage={label} />
      </NavLink>
    </NavItem>
  );
};

export default ItemMenu;
